import React from 'react';
import CommonZonesCreate from './create';
import CommonZonestList from './list';
import CommonZonestEdit from './edit';

const CommonZonesTitle = ({ record }) => {
    return <span>Editando la zona commún {record ? `${record.name}` : ''}</span>;
};

export { CommonZonesCreate, CommonZonestList, CommonZonesTitle, CommonZonestEdit };